module.exports = __webpack_public_path__ + "static/media/hotelPageSeparationIcon.7b502165.png";